import {
  IssueCodeDefinition,
  TopLevelIssueCategory,
} from '../../../../../redux/slice/aiReviewSliceV2';

export const createEmptyCategory = (): TopLevelIssueCategory => ({
  category_id: '',
  category_label: '',
  category_description: '',
});

export const createEmptyIssueCode = (): IssueCodeDefinition => ({
  code_id: '',
  code_name: '',
  category: '',
  priority: '',
  definition: '',
  include_if_any_apply: [''],
  exclude_if_any_apply: [''],
  responsive_examples: [''],
  non_responsive_examples: [''],
});

export const createEmptyStringListItem = (): string => '';

export const buildAddItemAriaLabel = (label: string, placeholder: string) =>
  `${placeholder.replace(/\.+$/, '').trim()} for ${label}`;

export const updateArrayItem = <T>(items: T[], index: number, value: T): T[] =>
  items.map((item, i) => (i === index ? value : item));

export const removeArrayItem = <T>(items: T[], index: number): T[] =>
  items.filter((_, i) => i !== index);

export const appendArrayItem = <T>(items: T[], value: T): T[] => [
  ...items,
  value,
];

export const matchesIssueCodeSearch = (
  code: IssueCodeDefinition,
  searchTerm: string
): boolean => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return true;

  return [
    code.code_id,
    code.code_name,
    code.category,
    code.definition,
    code.priority,
    ...code.include_if_any_apply,
    ...code.exclude_if_any_apply,
    ...code.responsive_examples,
    ...code.non_responsive_examples,
  ].some((value) => value.toLowerCase().includes(term));
};

/** AC search fields for approved-protocol view mode only. */
export const matchesIssueCodeViewSearch = (
  code: IssueCodeDefinition,
  searchTerm: string,
  categoryLabel?: string
): boolean => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return true;

  return [
    code.code_id,
    code.code_name,
    code.category,
    categoryLabel ?? '',
    code.priority,
    code.definition,
  ].some((value) => value.toLowerCase().includes(term));
};

export const resolveCategoryLabel = (
  categories: TopLevelIssueCategory[],
  categoryId: string
): string =>
  categories.find((category) => category.category_id === categoryId)
    ?.category_label || categoryId;

export const matchesIssueCodeCategory = (
  code: IssueCodeDefinition,
  categoryId: string | null
): boolean => {
  if (!categoryId) return true;
  return code.category === categoryId;
};

export const ALL_CATEGORIES_ID = 'ALL_CATEGORIES';
